import React, { useMemo } from "react";


const conversionData = [
    { rango: "0% - 50%", color: "#f20013", descripcion: "Bajo" },
    { rango: "51% - 75%", color: "#ffa500", descripcion: "Medio" },
    { rango: "76% - 100%", color: "#198754", descripcion: "Alto" }
];

function getColorByAvance(avance) {
    const pct = parseFloat(avance);
    const item = conversionData.find(({ rango }) => {
        const [low, high] = rango
            .split("-")
            .map(s => parseInt(s.replace("%", "").trim(), 10));
        return pct >= low && pct <= high;
    });
    return item ? item.color : "#000";
}

const PoaResumenTipoActividad = ({ data }) => {
    // 1) Aplanar todos los arrays detalle
    const allDetalles = useMemo(
        () => data.flatMap(proj => proj.detalle || []),
        [data]
    );

    // 2) Agrupar por tipo_actividad y sumar metas
    const resumenPorTipo = useMemo(() => {
        if (allDetalles.length === 0) return [];

        const grupos = allDetalles.reduce((acc, rec) => {
            const tipo = rec.indicador?.tipo_actividad || "Sin tipo";
            const meta = parseFloat(rec.indicador?.meta) || 0;
            const ejecutada = parseFloat(rec.indicador?.meta_ejecutada) || 0;

            if (!acc[tipo]) {
                acc[tipo] = {
                    tipo,
                    totalMeta: 0,
                    totalEjecutada: 0,
                };
            }
            acc[tipo].totalMeta += meta;
            acc[tipo].totalEjecutada += ejecutada;
            return acc;
        }, {});

        return Object.values(grupos).map(({ tipo, totalMeta, totalEjecutada }) => {
            const porcentaje =
                totalMeta > 0 ? (totalEjecutada / totalMeta) * 100 : 0;
            return {
                tipo,
                totalMeta,
                totalEjecutada,
                avance: porcentaje.toFixed(1),
            };
        });
    }, [allDetalles]);

    if (resumenPorTipo.length === 0) {
        return <p>No hay indicadores registrados.</p>;
    }

    return (
        <div className="poa-resumen">
            <h2>Consolidado por Tipo de Actividad</h2>
            <table>
                <thead>
                    <tr>
                        <th>Tipo de Actividad</th>
                        <th>Meta</th>
                        <th>Meta Ejecutada</th>
                        <th>Avance (%)</th>
                    </tr>
                </thead>
                <tbody>
                    {resumenPorTipo.map((f, i) => (
                        <tr key={i}>
                            <td>{f.tipo}</td>
                            <td style={{ textAlign: "center" }}>{f.totalMeta}</td>
                            <td style={{ textAlign: "center" }}>
                                {f.totalEjecutada != null
                                    ? parseFloat(f.totalEjecutada).toLocaleString("es-CO", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                    })
                                    : "-"}
                            </td>

                            <td style={{ textAlign: "center" }}>
                                <span
                                    style={{
                                        fontWeight: "bold",
                                        color: getColorByAvance(f.avance)
                                    }}
                                >
                                    {f.avance}%
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <style jsx>{`
        .poa-resumen {
          padding: 20px;
          background-color: #f9f9f9;
          border-radius: 8px;
        }
        h2 {
          margin-bottom: 20px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          padding: 10px;
          text-align: left;
          border-bottom: 1px solid #ddd;
        }
        th {
          background-color: #f2f2f2;
          text-align: center;
        }
      `}</style>
        </div>
    );
};

export default PoaResumenTipoActividad;
